import React, {createContext, useEffect, useReducer} from 'react';
import {Reducer} from '../reducers/WordList';
import {availableTagEntries} from '../helpers/availableTagEntries';

const STORAGE_KEY = 'vocabmaster-ui-prefs';

// Preferences that survive page reloads. Everything else in the state is
// transient session data.
function loadPersistedPrefs() {
  const defaults = {
    orderBy: 'wordFa',
    language: 'farsi',
    tagsFilter: availableTagEntries,
    hideTranslation: false,
  };

  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults;
    const saved = JSON.parse(raw);

    const language = saved.language === 'hebrew' ? 'hebrew' : 'farsi';
    const orderBy = saved.orderBy === 'wordEn' ? 'wordEn' : 'wordFa';
    const hideTranslation = Boolean(saved.hideTranslation);

    let tagsFilter = availableTagEntries;
    if (Array.isArray(saved.tagsFilter)) {
      const valid = saved.tagsFilter.filter(
          (tag) => availableTagEntries.includes(tag),
      );
      if (valid.length > 0) tagsFilter = valid;
    }

    return {orderBy, language, tagsFilter, hideTranslation};
  } catch {
    return defaults;
  }
}

const Store=({children})=>{
  const [state, dispatch] = useReducer(Reducer, undefined, () => ({
    items: [],
    lastWord: '',
    hasMoreItems: true,
    user: null,
    loading: false,
    ...loadPersistedPrefs(),
  }));

  // Persist UI preferences whenever they change.
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        orderBy: state.orderBy,
        language: state.language,
        tagsFilter: state.tagsFilter,
        hideTranslation: state.hideTranslation,
      }));
    } catch {}
  }, [state.orderBy, state.language, state.tagsFilter, state.hideTranslation]);

  return (
    <Context.Provider value={[state, dispatch]}>
      {children}
    </Context.Provider>
  );
};

export const Context = createContext();

export default Store;
